// El aviso que ven Promociones y Políticas cuando el catálogo de segmentos NO llegó. Sin él, el
// combo vacío y el id crudo se leen como datos, no como un hueco.
import { AlertTriangle } from 'lucide-react';
import { segmentCatalogNote, type SegmentCatalogPlace } from '../logic';
import type { SegmentCatalogState } from '../types';

export interface SegmentCatalogNoticeProps {
    state: SegmentCatalogState;
    /** Decide la frase y, con ella, cuál de los dos avisos anuncia. */
    place: SegmentCatalogPlace;
}

/** Nada que avisar cuando el catálogo llegó: el componente no pinta. */
export function SegmentCatalogNotice({ state, place }: SegmentCatalogNoticeProps) {
    const note = segmentCatalogNote(state, place);
    if (note === undefined) return null;

    // Anuncia SOLO el filtro. Dos regiones vivas con el mismo fallo lo repiten y se lee como dos
    // problemas distintos; el del selector se ve igual, en texto plano.
    return (
        <div
            role={place === 'filter' ? 'status' : undefined}
            className="flex items-start gap-1.5 text-[10.5px] leading-snug text-muted-foreground"
        >
            {state === 'loading' ? null : (
                <AlertTriangle className="mt-px size-3 flex-none text-warning" aria-hidden />
            )}
            <span>{note}</span>
        </div>
    );
}
